var serviceModule = angular.module('t2g.service', [
  'gettext',
  'ui.router',
  require('t2g.common.services.modalService').name,
  require('t2g.common.services.modelService').name,
  require('t2g.common.services.notificationService').name,
]);

module.exports = serviceModule;

serviceModule.controller('ServiceGroupModalCtrl', require('./modal/serviceGroupModalCtrl'));
serviceModule.controller('ServiceListCtrl', require('./list/listCtrl'));
serviceModule.controller('ServiceModalCtrl', require('./modal/serviceModalCtrl'));
serviceModule.controller('ServiceModalCtrlNew', require('./modal/ServiceModalCtrlNew'));
serviceModule.controller(
  'ServiceResourceMatchController',
  require('./serviceResourceMatch/ServiceResourceMatchCtrl'),
);

serviceModule.config(function($stateProvider) {
  $stateProvider
    .state('private.main.services', {
      url: '/services',
      title: 'Services',
      templateUrl: '/app/modules/service/list/ServiceListView.html?v=4.5.6',
      controller: 'ServiceListCtrl',
      resolve: {
        officeResolve: function(OfficeDA) {
          return OfficeDA.get();
        },
      },
    })
    .state('private.main.serviceResourceMatch', {
      url: '/serviceResourceMatch',
      title: 'Services',
      templateUrl:
        '/app/modules/service/serviceResourceMatch/ServiceResourceMatchView.html?v=4.5.6',
      controller: 'ServiceResourceMatchController as ServiceResourceMatchController',
      resolve: {
        officeResolve: function(OfficeDA) {
          return OfficeDA.get();
        },
        resourceResolve: function($q, ObjectModel) {
          var deffered = $q.defer();

          ObjectModel.get(function(error, response) {
            if (error) {
              deffered.reject(error);
            } else {
              deffered.resolve(response);
            }
          });

          return deffered.promise;
        },
      },
    });
});



// WEBPACK FOOTER //
// ./src/app/modules/service/serviceModule.js